module.exports = __webpack_public_path__ + "img/papyaga.e484acb7.jpeg";